export interface INewMessageModel {
    groupId: number;
    message: string;
}

export class NewMessageModel implements INewMessageModel {
    groupId: number;
    message: string;
}